module.exports = class Creator {
    constructor() {
        this.id     = 0;
        this.role   = '';
        this.name   = '';
    }
};
